/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function LocationName({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/LocationCount/LocationPopover/LocationName"
  
}) {
let connectionResourceLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'connection_resource',
path: 'location.name',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingLeft={dtSpaceXs}
 data="connection_resource.location.name"
 text={connectionResourceLocationNameValueData}
/>
{children}
</React.Fragment>)
}